import React, { useState } from "react";
import { GoPlus } from "react-icons/go";
import { Collapse, CardBody, Card } from "reactstrap";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { MdChecklist } from "react-icons/md";

const topicsData = {
  beginner: [
    {
      id: 1,
      title: "Introduction to Arrays, Vectors, and Matrices",
      lessons: 2,
      details: ["Array operations & memory layout", "Dynamic arrays & Vectors", "Matrix transformations", "2 Practice Challenges"]
    },
    {
      id: 2,
      title: "Linked Lists and Recursion Basics",
      lessons: 2,
      details: ["Singly & Doubly Linked Lists", "Recursion fundamentals & Call Stack", "Two-pointer techniques", "2 Practice Challenges"]
    },
    {
      id: 7,
      title: "String Algorithms & Sorting Techniques",
      lessons: 3,
      details: ["String parsing & manipulation", "Bubble, Merge, and Quick Sort", "Binary Search implementation", "3 Coding Problems"]
    }
  ],
  intermediate: [
    {
      id: 3,
      title: "Stacks, Queues, and Hash Tables",
      lessons: 3,
      details: ["LIFO/FIFO representations", "Hashing algorithms & collisions", "Sliding window problems", "3 Practice Challenges"]
    },
    {
      id: 4,
      title: "Trees, Graphs, and Search Algorithms",
      lessons: 3,
      details: ["Binary Tree traversals (DFS/BFS)", "Graph representations & paths", "Dijkstra's & MST algorithms", "3 Practice Challenges"]
    },
    {
      id: 8,
      title: "Greedy Algorithms and Heaps",
      lessons: 2,
      details: ["Greedy choice properties & Huffman coding", "Min-Heap & Max-Heap data structures", "Heap Sort & priority scheduling", "2 Coding Problems"]
    }
  ],
  advanced: [
    {
      id: 5,
      title: "Dynamic Programming Fundamentals",
      lessons: 2,
      details: ["Memoization vs Tabulation", "Knapsack & Grid pathfinding", "Optimal substructure analysis", "2 Practice Challenges"]
    },
    {
      id: 6,
      title: "System Design basics & Scalability",
      lessons: 2,
      details: ["Load balancers & Caching layers", "Database indexing & sharding", "Horizontal scaling design", "2 Case Studies"]
    },
    {
      id: 9,
      title: "Tries, Segment Trees, and Advanced Graphs",
      lessons: 3,
      details: ["Prefix Trees (Trie) insertions & searches", "Segment Trees for range queries", "Network flow & Tarjan's algorithms", "3 Coding Problems"]
    }
  ]
};

function LearningRoadmap() {
  const [activeTab, setActiveTab] = useState("beginner");
  const [openItem, setOpenItem] = useState(null);

  const toggle = (item) => {
    setOpenItem(openItem === item ? null : item);
  };

  const currentTopics = topicsData[activeTab] || [];

  return (
    <div className="roadmap-container">
      <div className="roadmap-header">
        <h6>
          Curated in three sections covering in-depth study of DS Algo,
          Computer Science Fundamentals, Low level design and System Design
        </h6>
        <h3>Your Learning Roadmap</h3>
      </div>

      <div className="nav nav-pills mb-4">
        <span 
          className={`nav-link ${activeTab === "beginner" ? "active" : ""}`} 
          onClick={() => { setActiveTab("beginner"); setOpenItem(null); }}
          style={{ cursor: "pointer" }}
        >
          Beginner
        </span>
        <span 
          className={`nav-link ${activeTab === "intermediate" ? "active" : ""}`} 
          onClick={() => { setActiveTab("intermediate"); setOpenItem(null); }}
          style={{ cursor: "pointer" }}
        >
          Intermediate
        </span>
        <span 
          className={`nav-link ${activeTab === "advanced" ? "active" : ""}`} 
          onClick={() => { setActiveTab("advanced"); setOpenItem(null); }}
          style={{ cursor: "pointer" }}
        >
          Advance
        </span>
      </div>

      {currentTopics.map((topic) => (
        <div key={topic.id} style={{ width: "100%", maxWidth: "640px", marginBottom: "8px" }}>
          <div className="faq-item" onClick={() => toggle(topic.id)} style={{ width: "100%", margin: 0 }}>
            <GoPlus className="faq-icon-plus" />
            <span className="faq-font">{topic.title}</span>
            <div className="d-flex align-items-center gap-3 ml-auto">
              <span className="small text-muted mr-3">
                <MdChecklist className="faq-icon-checklist mr-1" />
                {topic.lessons} Lessons
              </span>
              <span className="small text-muted">
                <HiQuestionMarkCircle className="faq-icon mr-1" />
                {topic.lessons} Quizzes
              </span>
            </div>
          </div>
          <Collapse isOpen={openItem === topic.id} style={{ width: "100%" }}>
            <Card className="faq-collapse" style={{ width: "100%", maxWidth: "100%", margin: 0 }}>
              <CardBody>
                <ul>
                  {topic.details.map((detail, idx) => (
                    <li key={idx}>
                      <MdChecklist className="li-icon" /> {detail}
                    </li>
                  ))}
                </ul>
              </CardBody>
            </Card>
          </Collapse>
        </div>
      ))}

      <button className="btn btn-primary mt-4 text-white">Download Plan</button>
    </div>
  );
}

export default LearningRoadmap;
